export default __webpack_public_path__ + "static/Kamal-4160fcffaaf1b2ceb2bf31d53a6d9793.png";